import { observer } from 'mobx-react-lite'
import SnoozeMenu from './components/SnoozeMenu'
import AccountMenu from './components/AccountMenu'

type GeneralPanelProps = {
  title: string
}

const GeneralPanel = ({ title }: GeneralPanelProps) => {
  return (
    <header className="flex flex-row items-center justify-between flex-none min-h-[70px] p-5 pr-0 bg-white shadow sticky top-0 right-0 w-full z-[1100] box-border">
      <h5 className="typography-body-xxl tracking-tight text-primary-800">{title}</h5>
      <div className="flex justify-between items-center min-w-[112px]">
        <SnoozeMenu />
        <AccountMenu />
      </div>
    </header>
  )
}
export default observer(GeneralPanel)
